import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  datas: {},
};

export const authSlice = createSlice({
  name: "rentacar_analyse_store",
  initialState,
  reducers: {
    setDatas: (state, action) => {
      state.datas = action.payload.datas;
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem("token", action.payload.token);
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("token");
    },
  },
});

export const { setDatas, setLogin, setLogout } = authSlice.actions;
export default authSlice.reducer;
